import React from 'react';
import { useMultiReports } from '../MultiReportsContext';
import { OtherFieldsMetrics, PmeMetrics } from './MetricsPanel';

export function Filters() {
  const { 
    dateRange, 
    setDateRange, 
    searchValue, 
    setSearchValue,
    activeFieldTab,
    activeFields,
    discountFilters,
    setDiscountFilters
  } = useMultiReports();

  const getDateFieldLabel = () => {
    if (activeFieldTab === 'discounts') {
      return 'DMS Invoice Date';
    }
    return 'Booking Date';
  };

  return (
    <div className="bg-white p-4 rounded-xl border shadow-sm">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">{getDateFieldLabel()} From</label>
          <input
            type="date"
            value={dateRange.from}
            onChange={(e) => setDateRange(prev => ({ ...prev, from: e.target.value }))}
            className="w-full p-2 border rounded text-sm"
            data-testid="date-from"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">{getDateFieldLabel()} To</label>
          <input
            type="date"
            value={dateRange.to}
            onChange={(e) => setDateRange(prev => ({ ...prev, to: e.target.value }))}
            className="w-full p-2 border rounded text-sm"
            data-testid="date-to"
          />
        </div>
        <div className="md:col-span-2">
          <label className="block text-xs font-medium text-gray-600 mb-1">Search</label>
          <input
            type="text"
            placeholder="Search by name, mobile, booking no, chassis..."
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            className="w-full p-2 border rounded text-sm"
            data-testid="search-input"
          />
        </div>
      </div>
      
      {/* Discount Filters - Only show on Discounts tab */}
      {activeFieldTab === 'discounts' && (
        <div className="mt-4 pt-4 border-t">
          <p className="text-xs font-medium text-gray-600 mb-2">Filter by Discount Fields</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {activeFields.map(field => (
              <div key={field.id}>
                <label className="block text-xs text-gray-500 mb-1">{field.label}</label>
                <select
                  value={discountFilters[field.id] || 'all'}
                  onChange={(e) => setDiscountFilters(prev => ({ ...prev, [field.id]: e.target.value }))}
                  className="w-full p-2 border rounded text-xs"
                  data-testid={`filter-${field.id}`}
                >
                  <option value="all">All</option>
                  <option value="blank">Blank / Zero</option>
                  <option value="filled">Has Value</option>
                </select>
              </div>
            ))}
          </div>
        </div>
      )}
      
      {/* Other Fields Metrics and Filters */}
      {activeFieldTab === 'other_status' && <OtherFieldsMetrics />}
      
      {/* PME Metrics and Filters */}
      {activeFieldTab === 'pme' && <PmeMetrics />}
    </div>
  );
}
